const DATAPLUS_ACTIONS_OVERALL = [
  'dataplus:viewPage',
  'dataplus:viewPage:overview',
];

const DATAPLUS_ACTIONS = [
  'dataplus:viewPage',
  'dataplus:viewPage:pillars',
  'dataplus:viewPage:metrics',
  'dataplus:viewPage:benchmark-summary',
  'dataplus:viewPage:bibliometric-analysis',
  'dataplus:viewPage:detailed-subjects',
  'dataplus:viewPage:peer-group-analysis',
  'dataplus:viewPage:subjects',
  'dataplus:viewPage:year-on-year',
  'dataplus:viewPage:institution-finder',
];

const DATAPLUS_ACTION_ESSENTIAL = [
  'dataplus:viewPage',
  'dataplus:viewPage:pillars',
  'dataplus:viewPage:metrics',
  'dataplus:viewPage:benchmark-summary',
  'dataplus:viewPage:bibliometric-analysis',
  'dataplus:viewPage:institution-finder',
];

const DATAPLUS_ACTION_CORE = [
  ...DATAPLUS_ACTION_ESSENTIAL,
  'dataplus:viewPage:year-on-year',
];

const DATAPLUS_ACTION_EMBARGO = [
  'dataplus:viewPage:overview-embargo',
  'dataplus:viewPage:pillars-embargo',
  'dataplus:viewPage:metrics-embargo',
  'dataplus:viewPage:benchmark-summary-embargo',
  'dataplus:viewPage:bibliometric-analysis-embargo',
  'dataplus:viewPage:detailed-subjects-embargo',
  'dataplus:viewPage:peer-group-analysis-embargo',
  'dataplus:viewPage:subjects-embargo',
  'dataplus:viewPage:year-on-year-embargo',
  'dataplus:viewPage:institution-finder-embargo',
];
const DATAPLUS_ACTION_FREE_EMBARGO = [
  'dataplus:viewPage:overview-free-embargo',
  'dataplus:viewPage:pillars-free-embargo',
  'dataplus:viewPage:metrics-free-embargo',
  'dataplus:viewPage:benchmark-summary-free-embargo',
  'dataplus:viewPage:bibliometric-analysis-free-embargo',
  'dataplus:viewPage:detailed-subjects-free-embargo',
  'dataplus:viewPage:peer-group-analysis-free-embargo',
  'dataplus:viewPage:subjects-free-embargo',
  'dataplus:viewPage:year-on-year-free-embargo',
  'dataplus:viewPage:institution-finder-free-embargo',
];
const DATAPLUS_ACTION_CORE_EMBARGO = [
  'dataplus:viewPage:overview-embargo',
  'dataplus:viewPage:pillars-embargo',
  'dataplus:viewPage:metrics-embargo',
  'dataplus:viewPage:benchmark-summary-embargo',
  'dataplus:viewPage:bibliometric-analysis-embargo',
  'dataplus:viewPage:year-on-year-embargo',
  'dataplus:viewPage:institution-finder-embargo',
];
const DATAPLUS_ACTION_ESSENTIAL_EMBARGO = [
  'dataplus:viewPage:overview-embargo',
  'dataplus:viewPage:pillars-embargo',
  'dataplus:viewPage:metrics-embargo',
  'dataplus:viewPage:benchmark-summary-embargo',
  'dataplus:viewPage:bibliometric-analysis-embargo',
  'dataplus:viewPage:institution-finder-embargo',
];

const DATAPLUS_ACTION_TABLEAU = ["dataplus:viewTableauDashboard"];

module.exports = {
  DATAPLUS_ACTION_CORE,
  DATAPLUS_ACTION_ESSENTIAL,
  DATAPLUS_ACTIONS_OVERALL,
  DATAPLUS_ACTIONS,
  DATAPLUS_ACTION_EMBARGO,
  DATAPLUS_ACTION_FREE_EMBARGO,
  DATAPLUS_ACTION_CORE_EMBARGO,
  DATAPLUS_ACTION_ESSENTIAL_EMBARGO,
  DATAPLUS_ACTION_TABLEAU,
};
